import { LoadingView } from '~/components/LoadingView'
import { BuyerProfileView } from '~/components/user/buyers/BuyerProfileView'
import RealtorProfileView from '~/components/user/realtors/RealtorProfileView'
import { SelectRole } from '~/components/user/SelectRole'
import { useUserProfile } from '~/data/user/userProfile'

export function ProfileView() {
  const { data: profile, isLoading } = useUserProfile()
  const roles = profile?.roles ?? []

  if (isLoading) {
    return <LoadingView />
  }

  if (roles.includes('realtor')) {
    return <RealtorProfileView />
  }

  if (roles.includes('buyer')) {
    return <BuyerProfileView />
  }

  if (!roles?.length) {
    return <SelectRole />
  }
}
